<template>
  <div>
    <p>זמן הטיפול במשימה היה ארוך מהזמן שהוגדר לה. נא לפרט את הסיבה לעיכוב:</p>
    <textarea class="full_width mt-4" v-model="innerText" placeholder="..."></textarea>
    <div class="modal_footer">
      <button @click="submit" :disabled="textValidation" class="button is-info mx-3">Submit</button>
    </div>
  </div>
</template>

<script>
const MINIMUM_TEXT_LENGTH = 5

export default {
  name: 'FeedAlertTimeExceed',
  props: {
    alert: {
      type: Object
    },
    duration: {
      type: String
    },
    time_estimation: {
      type: [String, Number]
    },
    onSubmit: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      innerText: null
    }
  },
  computed: {
    textValidation () {
      return !(this.innerText && this.innerText.replace(/[,. \t\n]/g, '').length > MINIMUM_TEXT_LENGTH)
    },
    fullName () {
      switch (this.alert.resource_type) {
        case 'Company':
          return `${this.alert.resources.company.name} -`
        case 'Applicant':
          return `${this.alert.resources.applicant.full_name} ${this.$utils.getVetted(this.alert.resources.applicant)} -`
        case 'Position':
          return `${this.alert.resources.position.title} ${this.alert.resources.position.is_discrete ? '(DISCRETE)' : ''} -`
        default:
          return ''
      }
    }
  },
  methods: {
    submit () {
      this.$network_utils.postStat({
        title: `${this.fullName} ${this.alert.designator}`,
        designator: 'time_exceeded_alert',
        content: `זמן מצופה: ${this.time_estimation} ${'\n'} זמן בפועל: ${this.duration} ${'\n'} ${this.alert.owner} - ${this.innerText}`,
        status: 'active',
        owner: this.alert.owner,
        priority: 5,
        resource_type: 'Alert',
        resource_id: this.alert.id
      })
      this.onSubmit(this.$attrs.payload.modal_id)
    }
  }
}
</script>
